module.exports = "<left-menu></left-menu>\r\n<div class=\"col-sm-9 padding-right\">\r\n  <div class=\"features_items\" id=\"contenedor-productos\"><!--features_items-->\r\n    <h1 class=\"title text-center\">{{categoria.categoriaNombre}}</h1>\r\n\r\n    <div class=\"row\">\r\n      <product-mini *ngFor=\"let producto of listProductos\" [producto]=\"producto\"></product-mini>\r\n    </div>\r\n\r\n  </div><!--features_items-->\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/category/category.component.html
// module id = 580
// module chunks = 1